import { HttpClient } from "../api/httpclient.service";

export class UserService extends HttpClient {
  constructor() {
    super();
  }

  public async updateUserAttribute(att_name: string, att_value: any) {
    try {
      const response = await this.put('/user/user_attributes', { att_name, att_value });
      return response;
    } catch (error: any) {
      console.error('Update user attribute error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getOrganizations() {
    try {
      return await this.get("/organization/organizations");
    } catch (error: any) {
      console.error('Get organizations error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getOrganizations_By_OrgId(org_id: number) {
    try {
      return await this.get(`/organization/organizations/${org_id}`);
    } catch (error: any) {
      console.error('Get organization by id error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getTeachers(org_id?: number) {
    try {
      return this.get(`/user/teachers?org_id=${org_id}`);
    } catch (error: any) {
      console.error('Get teachers error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getClasses() {
    try {
      return this.get("/data/get_classes");
    } catch (error: any) {
      console.error('Get classes error:', error.response?.data || error.message);
      throw error;
    }
  }

  async updateUserProfile(data: any) {
    try {
      return this.put("/user/users/update_user", data);
    } catch (error: any) {
      console.error('Update user error:', error.response?.data || error.message);
      throw error;
    }
  }

  async get_user_login_count() {
    try {
      return this.put("/user/get_user_logins");
    } catch (error: any) {
      console.error('Update user error:', error.response?.data || error.message);
      throw error;
    }
  }

  public async fetchStudetList(
    page: number,
    pageSize: number,
    user_type?: string,
    school?: string,
    teacher?: string,
    level?: string,
    search?: string
  ) {
    try {
      const body = {
        search: search || '',
        page: page,
        page_size: pageSize,
        user_type: user_type || '',
        org_id: school ? parseInt(school) : null,
        teacher_id: teacher ? parseInt(teacher) : null,
        level_id: level ? parseInt(level) : null,
      };

      const response = await this.post('/user/get_student_list', body);
      return response;
    } catch (error) {
      console.error("Error searching student in DB:", error);
      return { results: [], total: 0 };
    }
  }

  public async fetchStudetCount() {
    try {
      const response = await this.get('/user/get_students_count');
      return response;
    } catch (error) {
      console.error("Error during fetch student count in DB:", error);
      return { results: [], total: 0 };
    }
  }

  async validateOrganizationCode(org_code: string) {
    try {
      const response = await this.post("/organization/validate_organization_code", { org_code });
      return response;
    } catch (error: any) {
      console.error('Validate organization code error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getCurrentUser() {
    try {
      return await this.get("/user/profile");
    } catch (error: any) {
      console.error('Get current user error:', error.response?.data || error.message);
      throw error;
    }
  }

  async getReturningUserSessionMetadata() {
    try {
      return await this.get("/user/get-returning-user-session-metadata");
    } catch (error: any) {
      console.error('Get returning user session metadata error:', error.response?.data || error.message);
      throw error;
    }
  }
}

